const NewsPageNextIcon = (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="month"
  >
    <path
      d="M35.5089 19.0386C35.5089 28.804 27.6657 36.7127 18 36.7127C8.33435 36.7127 0.491143 28.804 0.491143 19.0386C0.491143 9.27326 8.33435 1.36456 18 1.36456C27.6657 1.36456 35.5089 9.27326 35.5089 19.0386Z"
      fill="white"
      stroke="#9F9F9F"
      strokeWidth="0.982287"
    />
    <path
      d="M14.6667 12.3108L21.3334 19.0386L14.6667 25.7665"
      stroke="#444444"
      strokeWidth="1.47343"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NewsPageNextIcon;
